import { ConfigProvider, Menu } from "antd";
import React from "react";
import { Link, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { clearJwt } from "../utils/authStorage";

const HorizontalMenu = ({ menuItems, justify }) => {
  const location = useLocation();
  // Under HashRouter (desktop build) the route can briefly still be readable only
  // via location.hash before the router settles — fall back to it so the menu
  // highlight doesn't flash back to "/". No-op under BrowserRouter (web build).
  const routeKey = location.pathname && location.pathname !== '/' ? location.pathname : (location.hash ? location.hash.replace(/^#/, '') : '/');

  const handleLogout = () => {
    console.log("logging out");
    clearJwt();
    window.location.reload();
  };

  return (
    <ConfigProvider 
      theme={{
        components: {
          Menu: {
            darkItemBg: "#001529",
            darkItemSelectedBg: "#0065c56b",
          }
        }
      }}
    >

    
    <Menu
      selectedKeys={[routeKey]}
      style={{ paddingRight: 20, justifyContent: justify }}
      theme="dark"
      mode="horizontal"
      items={menuItems.map((item) => {
        if (item.key === "logout") {
          // If it's the second item (index is 0-based)
          return {
            key: item.path,
            label: item.title,
            icon: item.icon,
            onClick: handleLogout,
          };
        } else {
          return {
            key: item.path,
            label: <Link to={item.path}>{item.title}</Link>,
            icon: item.icon,
          };
        }
      })}
    ></Menu>
    </ConfigProvider>
  );
};

HorizontalMenu.propTypes = {
  menuItems: PropTypes.array.isRequired,
  justify: PropTypes.string,
};

export default HorizontalMenu;
